'use client';

import { useCopyLink } from './use-copy-link';
import { CopyLinkServer } from './copy-link-server';

export default function CopyLinkClient({ url }: { url: string }) {
  const { copied, copy } = useCopyLink(url);

  return <CopyLinkServer onClick={copy} copied={copied} />;
}
